'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';

export function GtmManager() {
  const pathname = usePathname();
  const isKlaviyoFormPage = pathname === '/klaviyo-form';

  if (isKlaviyoFormPage) {
    return null;
  }

  return <GoogleTagManager gtmId="GTM-TSG6CH22" />;
}
